import { render, staticRenderFns } from "./datasearch.vue?vue&type=template&id=a3f194be&scoped=true&"
import script from "./datasearch.vue?vue&type=script&lang=js&"
export * from "./datasearch.vue?vue&type=script&lang=js&"
import style0 from "./datasearch.vue?vue&type=style&index=0&id=a3f194be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f194be",
  null
  
)

export default component.exports